import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { ServiceForm } from './service.form';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyServicesService } from '../my-services.service';
import { serviceProviderTypeDescriptions } from '../../service-provider-type.enum';
import { UIControlService } from 'src/app/shared/uicontrol.service';
import { MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { FormArray, FormControl } from '@angular/forms';

@Component({
  selector: 'app-service-form',
  templateUrl: './service-form.component.html',
  styleUrls: ['./service-form.component.scss']
})
export class ServiceFormComponent implements OnInit {
  @Input() public formModel: ServiceForm;
  @Output() public deleted = new EventEmitter<ServiceForm>();
  public serviceProviderTypeDescriptions = serviceProviderTypeDescriptions;
  public saving = false;
  public readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('locationList') public locationList: MatChipList;

  get locationsFormArray(): FormArray {
    return this.formModel.formGroup.controls.locations as FormArray;
  }

  constructor(
    private myServicesService: MyServicesService,
    private ui: UIControlService
  ) {}

  public ngOnInit(): void {
    this.locationsFormArray.statusChanges.subscribe(
      status => (this.locationList.errorState = status === 'INVALID')
    );
  }

  public save() {
    if (this.formModel.formGroup.valid) {
      this.saving = true;
      this.saveOrCreate(this.formModel).subscribe(
        () => this.ui.notifySuccess('Service saved successfully!'),
        error => {
          console.error(error);
          this.ui.notifyFailure(
            'Something went wrong while trying to save. Please try again in a few minutes.'
          );
        },
        () => (this.saving = false)
      );
    } else {
      this.locationList.errorState =
        this.locationsFormArray.status === 'INVALID';
      this.ui.notifyFailure(
        'Cannot save as not all details are valid. Please correct the above errors.'
      );
    }
  }

  public uploadFile() {
    const fileUpload = document.getElementById(
      'fileUpload'
    ) as HTMLInputElement;
    fileUpload.onchange = () => {
      if (fileUpload.files.length === 1) {
        this.formModel.uploadFile(fileUpload.files[0]);
      }
    };
    fileUpload.click();
  }

  public delete() {
    this.deleted.emit(this.formModel);
  }

  public addLocation(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.locationsFormArray.push(new FormControl(value.trim()));
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  public removeLocation(index: number): void {
    this.locationsFormArray.removeAt(index);
  }

  private saveOrCreate(formModel: ServiceForm): Observable<any> {
    if (!!formModel.documentKey) {
      return this.myServicesService.saveService(
        this.formModel.documentKey,
        this.formModel.model
      );
    } else {
      return this.myServicesService
        .createService(this.formModel.model)
        .pipe(map(docKey => (this.formModel.documentKey = docKey)));
    }
  }
}
